import controller from './tree.controller';

const template = require('./tree.html');

export default {
    bindings: {
        data: '<',
        selectedFolderId: '<',
        onFolderSelected: '&',
        onFolderCreated: '&',
        onFolderMoved: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-tree/tree.component.js